import React from "react";
import "./Shipping.css";

function Shipping() {
  return (
    <>
      <div className="shipping">
        <h1>Shipping & Returns</h1>
        <h2>Processing time</h2>
        <p>
          All Rubia’s styles are carefully handmade to order. Since each piece
          is made-to-order, we ask that you allow 7-10 business days (excluding
          weekends) before we ship your order. If you need to meet a certain
          (specific) deadline or need expedited shipping, we may be able to
          accommodate your request. Please email us at rubiacare@gmail.com
        </p>

        <h2>Returns</h2>
        <p>We gladly accept returns and exchanges.</p>

        <p>
          Just contact us within: 5 days of delivery, and ship items back to us
          within: 14 days of delivery
        </p>

        <p>
          If you would like to make a return please email for a return
          authorization at rubiacare@gmail.com(no refund will be granted without
          return authorization)
        </p>

        <p>
          Returns after the 14 day period are only eligible for store credit up
          to 30 days after the delivery date.
        </p>

        <p>
          For your protection, please pack your returns in the original box,
          return your order with an insured trackable courier & retain your
          receipt. Rubia is not responsible for items damaged or lost in
          transit. Please include a note with your name and invoice number. We
          can not refund shipping charges on return items.
        </p>

        <p>
          Once your return is received and inspected, we will send you an email
          notifying you that we have received your returned item(s). This email
          will also confirm that your refund has been issued. Please allow 1-3
          days for this process.
        </p>

        <h2>The following items can't be returned or exchanged</h2>

        <p> 
          Because of the nature of these items, unless they arrive damaged or
          defective, we can't accept returns or exchanges for:
        </p>
        <p>Custom or personalized orders</p>
        <p>Eternity Bands made to order</p>
        <p>Items on Sale</p>
        <p>Items Purchased During a Sales Event</p>

        <h2>Conditions of Return</h2>
        <p>
          Buyers are responsible for return shipping costs. The items must be
          shipped back in its original condition and packaging.
        </p>
        <h2>Cancellations</h2>

        <p>
          You may request a cancellation within 24 hour of purchase. An address
          change could be applied any time before your order has shipped. Please
          contact us directly at rubiacare@gmail.com with your order number in
          the subject line.
        </p>
      </div>
    </>
  );
}

export default Shipping;
